export default "__VITE_ASSET__BGqkEF1Z__"